<template>
  <div class="">
    <v-header :inputName='Name'></v-header>
    <v-serch ref="vserch" typename="jobzhiyuan"  @search="searchName"></v-serch>
    <jobtype1 @select="selectType"></jobtype1>
    <div class="xunhuan container">
      <ul :class="{'gudingo':guding}" class="" id="yuanshu1">
        <li>一级分类</li>
        <li>二级分类</li>
        <li>职业名称</li>
        <li>查看职业</li>
        <li>职业收藏</li>
      </ul>
      <div   id="yuanshu2" style="min-height: 500px;">
        <div class="xh" v-for="(item,i) in list">
          <div class="kuang">
            <span>{{item.jobFirstType}}</span>
          </div>
          <div class="kuang">
            <span>{{item.jobSecondType}}</span>
          </div>
          <div class="kuang">
            <span>{{item.jobName}}</span>
          </div>
          <div class="kuang">
            <el-button type="danger" @click="openinfo(item.jobId)" round icon="el-icon-search" size="mini">查看职业</el-button>
          </div>
          <div class="kuang" @click="shou(item.jobId)">
            <router-link to="" class="a2" :class="{'wenzhis':true}" v-if="userCang.indexOf(item.jobId)==-1">收藏
              <img src="../../assets/img/xing2.png">
            </router-link>
            <router-link to="" class="a2" :class="{'wenzhis':false}" v-else>已收藏
              <img src="../../assets/img/xing1.png">
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="showcaozuo">
      <div class="maskA" style="width:1000px;">
        <div class="maskAA"  style="width:1000px;">
          <p>{{showobj.jobName}}</p>
          <img @click="showcaozuo = false" src="../../assets/img/cha.png" />
        </div>
        <div class="ANANi" style="max-height: 400px;">
          <div v-if="showobj.jobFirstCode== null&&showobj.jobSummary!=null" class="zhiyeShow" v-html="showobj.jobSummary">

          </div>
          <div v-if="showobj.jobFirstCode!=null">
            <figure>
              <figcaption style="width: 115px;">职业概要&nbsp;:&nbsp;&nbsp;&nbsp;</figcaption>
              <figcaption style="width: 850px;text-indent: 0">{{showobj.jobSummary}}</figcaption>
            </figure>
            <el-row>
              <el-col :span="10">
                  <el-table
                      :data="jobMajortableData"
                      height="350"
                      border
                      stripe
                      style="width: 100%">
                      <el-table-column
                        prop="name"
                        label="专业">
                      </el-table-column>
                      <el-table-column
                        prop="time"
                        label="学制"
                        width="80">
                      </el-table-column>
                      <el-table-column
                        prop="rate"
                        width="80"
                        label="男女比">
                      </el-table-column>
                    </el-table>
              </el-col>
              <el-col :span="12" style="height: 350px;overflow-y: auto;">
                 <!-- <el-progress :percentage="50">
                       <template #default="{ percentage }">
                         <span>{{ percentage }}% 已完成</span>
                       </template>
                     </el-progress> -->
                <figure v-for="item in cityobj" >
                  <figcaption>
                    <div v-for="it in item" style="flex-direction: row;display: flex;">
                        <div>{{it.city}}</div>
                        <div style="min-width: 180px;">{{it.name}}</div>
                        <div>薪资：<b style="color: red;">{{it.pay}}</b></div>
                    </div>
                  </figcaption>
                </figure>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <zuoxuanfu1></zuoxuanfu1>
    <item7></item7>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import zuoxuanfu1 from '../../components/zuoxuanfu1.vue'
  import vSerch from '../../components/vSerch.vue'
  import jobtype1 from '../../components/jobtype1.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      zuoxuanfu1,
      jobtype1,
      vSerch
    },
    data() {
      return {
        // 头固定
        guding: false,
        // 导航选中
        Name: 3,
        majorName:'',
        list: [],
        typeId: "",
        userCang:[],
        showcaozuo:false,
        showobj:null,
        jobMajortableData:[],
        jobPostData:[],
        cityobj:{},

      }
    },
    mounted() {
      let userCang = this.$utils.getlocalStorage('userCang')
      if(userCang!=null&&userCang!=''&&userCang.job!=null){
        this.userCang = userCang.job
      }
      window.addEventListener('scroll', this.handleScrollx, true)
    },
    methods: {
      openinfo(jobId){
        let _this = this;
        this.$req.selectOne('jobTable', {"id":jobId}).then(function(response) {
          _this.showcaozuo = true;
          _this.showobj = response.data;
          _this.getjobMajor()
          _this.getjobPost()
        })

      },
      searchName(name) {
        this.majorName = name
        if(name == null||name == ''){
          return ;
        }
        this.typeId = '';
        this.getJob()
      },
      getjobMajor(){
        console.log(11)
        this.jobMajortableData = [];
        if(this.showobj.jobMajor!=null){
          let list = this.showobj.jobMajor.split(";")
          for(let i in list){
            let obj = list[i].split(",");
            this.jobMajortableData.push({name:obj[1],time:obj[2],rate:obj[5]})
          }
        }
      },
      getjobPost(){
        if(this.showobj.jobPost!=null){
          this.cityobj = {};
          let list = this.showobj.jobPost.split(";")
          for(let i in list){
            let obj = list[i].split(",");
            let city = obj[2]
            if(this.cityobj[city]==null){
              let o = [];
              o.push({name:obj[0],pay:obj[1],city:obj[2]})
              this.cityobj[city] = o
            } else {
              this.cityobj[city].push({name:obj[0],pay:obj[1],city:obj[2]})
            }

            // this.cityList.push({name:obj[0],pay:obj[1],city:obj[2]})
          }
          console.log(this.cityobj)
        }
      },
      handleScrollx() {
		  if(this.$route.path == '/zhuanyezhiyuan'){
			  let tedItem = document.querySelector("#yuanshu1")
			  let tedItem2 = document.querySelector("#yuanshu2")
			  var scrollTop = tedItem.getBoundingClientRect().top
			  var scrollTop2 = tedItem2.getBoundingClientRect().top
			  if (scrollTop <= 0) {
			    this.guding = true
			  }
			  if (scrollTop2 >= 52) {
			    this.guding = false
			  }
		  }

      },
      shou(id) {
      	let _this = this;
      	let flag1 = this.$utils.getLoginStatus();
      	if (flag1) {
      		let obj = this.$utils.getlocalStorage('userCang')
      		let list = obj.job
      		if (list.indexOf(id) == -1) {
      			_this.$req.insert("collectionTable", {
      				dataType: 5,
      				dataId: id
      			}).then(function(resp) {
      				if (resp.status == 0) {
      					list.push(id);
      					_this.userCang = list
      					obj.job = list
      					_this.$utils.setlocalStorage("userCang", obj);
      				}
      			})

      		} else {
      			_this.$req.batchDelete("collectionTable", {
      				data_type: 5,
      				data_id: id
      			}).then(function(resp) {
      				if (resp.status == 0) {
      					list.splice(list.indexOf(id), 1);
      					_this.userCang = list
      					obj.job = list
      					_this.$utils.setlocalStorage("userCang", obj);
      				}
      			})
      		}
      	}
      },
      selectType(code) {
        this.typeId = code
        this.$refs.vserch.clear();
        this.majorName = '';
        this.getJob()
      },


      getJob() {
        let _this = this;
        let obj = {}
        if(_this.typeId!=null&&_this.typeId!=''){
          obj.jobSecondCode =  _this.typeId
        }
        if(_this.majorName!=null&&_this.majorName!=''){
          obj.jobName =  _this.majorName
          // obj.jobSecondCode = null
        }
        this.$req.queryAllByLimit('jobTable', {
          pageNum: -1,
          pageSize: 0,
          queryObj: obj
        }).then(function(response) {
          _this.list = response.data
        })
      },
      // handleScroll () {
      //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      //   // console.log(scrollTop)

      // },
    }


  }
</script>

<style scoped>
  .gudingo {
    position: fixed;
    top: 90px;
    left: ;
    transform: translate(0);
    margin-top: 0 !important;
    width: 1458px !important;
    z-index: 9;
  }
  .zhiyeShow{
    font-size: 16px;
  }

  /* .gudingo li{flex-shrink: 0;} */

  .xunhuan ul {
    width: 100%;
    height: 50px;
    background: rgba(246, 100, 100, 1);
    opacity: 1;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .xunhuan ul li {
    width: 25%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .kuang {
    border: 1px solid #EBE9E9;
    width: 25%;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .wenzhis {
    color: #C8C8C8 !important;
  }

  .xunhuan .a2 {
    text-decoration: none;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    color: #FE9603;
    opacity: 1;
    display: flex;
    align-items: center;
  }

  .xunhuan .a2 img {
    margin-left: 5px;
  }

  .xunhuan .a1 {
    text-decoration: none;
    color: #29A7E1;
    font-size: 18px;
    font-weight: 500;
    line-height: 20px;
    color: #29A7E1;
    opacity: 1;
  }

  .xunhuan {
    color: #666666;
    text-align: center;
    justify-content: space-evenly;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
  }

  .xh {
    display: flex;
    margin-bottom: 5px;
  }

  .container {
    width: 1280px !important;
  }
/* 遮罩层  ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .maskA {
    width: 500px;
    /* height: 300px; */
    padding-bottom: 30px;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 47%;
    top: 45%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 500px;
    height: 50px;
    background-image: url("../../assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANANi {
    width: 100%;
    padding-bottom: 10px;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 10px;
    /* height: calc(100% - 170px); */
    /* height: 380px; */
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .ANANi figure {
    display: flex;
    margin-bottom: 18px;

  }

  .ANANi figure span {
    margin-right: 15px;
    background-color: #F44F25;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 18px;
    border-radius: 15px;
    width: 25px;
    height: 25px;
  }

  .ANANi figure figcaption {
    text-indent: 0.5cm;
    font-size: 16px;
    /* line-height: 30px; */
    color: #F53824;
    font-family: PingFang SC;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/views/information/job.vue